import { render, staticRenderFns } from "./BonusCategoryList.vue?vue&type=template&id=70a7558a"
import script from "./BonusCategoryList.vue?vue&type=script&lang=js"
export * from "./BonusCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports